import Authorizing from '@/pages/authorization';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(auth)/authorization')({
  component: RouteComponent,
});

function RouteComponent() {
  return <Authorizing />;
}
